// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SetUserStatusRequestModel from '../../model/set-user-status-request-model';
import SetUserStatusRequestDTO from '../dto/set-user-status-request-dto';
import dtoSchema from '../schemas/set-user-status-request-schema';

export default abstract class SetUserStatusRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SetUserStatusRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.newStatusId = data.newStatusId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int32}
  */
  newStatusId?: number;

  static toModel(dto: DeepPartial<SetUserStatusRequestDTO>): SetUserStatusRequestModel;
  static toModel(dto: DeepPartial<SetUserStatusRequestDTO> | undefined | null): SetUserStatusRequestModel | undefined;
  static toModel(dto: DeepPartial<SetUserStatusRequestDTO> | undefined | null): SetUserStatusRequestModel | undefined {
    return dto ? new SetUserStatusRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SetUserStatusRequestModel> | SetUserStatusRequestModel): SetUserStatusRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      newStatusId: unwrapped.newStatusId,
    } as SetUserStatusRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SetUserStatusRequestModel, can not map to SetUserStatusRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
